import { createReducer, on } from '@ngrx/store';
import {
	LOCAL_CHANNEL_FIND_SUCCESS,
	LOCAL_CHANNEL_FAILED,
	LOCAL_CHANNEL_UPDATE_LOADING,
	LOCAL_CHANNEL_UPDATE_ID,
	LOCAL_CHANNEL_FIND_SESION_SUCCESS,
	LOCAL_CHANNEL_RESET_STATE,
} from '../actions';
import { LocalChannel } from '@core/models';
import { JuvoTrackSession } from '@core/domain/local-channel';

export interface LocalChannelState {
	loading: boolean;
	localChannel: LocalChannel[] | null;
	error: string | null;
	localChannelId: string | null;
	sesion: JuvoTrackSession | null;
}

const initialState: LocalChannelState = {
	loading: false,
	localChannel: null,
	localChannelId: null,
	error: null,
	sesion: null,
};

export const localChannelReducer = createReducer(
	initialState,
	on(LOCAL_CHANNEL_FIND_SUCCESS, (state, { localChannel }) => ({ ...state, localChannel })),
	on(LOCAL_CHANNEL_UPDATE_ID, (state, { localChannelId }) => ({ ...state, localChannelId })),
	on(LOCAL_CHANNEL_FAILED, (state, { error }) => ({ ...state, error })),
	on(LOCAL_CHANNEL_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
	on(LOCAL_CHANNEL_FIND_SESION_SUCCESS, (state, { sesion }) => ({ ...state, sesion })),
	on(LOCAL_CHANNEL_RESET_STATE, () => ({ ...initialState }))
);
